import * as type from './type'
import * as selector from './selector'
import { IPR_INSTRUCTION, DO_NOT_MOVE, EXISTING_CONDITION, INSTRUCTION_LIST, LEAVE_SPACES_OPEN } from './const'
import { post } from '../../../../util/api'

function fixIPRInstructions(instructions){
    if (instructions === null) {
        return null;
    }

    const filtered = Object.keys(instructions).reduce((rest, k) => {
        if (instructions[k] !== null) {
            rest[k] = instructions[k];
        }
        return rest;
    }, {});

    if (Object.keys(filtered).length === 0) {
        return null
    }

    return filtered;
}


export const treatmentPlanLoaded = (treatmentPlan) => {
    if (!treatmentPlan) {
        return ({
            type: type.TREATMENT_PLAN_LOADED,
            payload: {
                treatmentPlan,
            },
        })
    }

    return ({
        type: type.TREATMENT_PLAN_LOADED,
        payload: {
            treatmentPlan: {
                ...treatmentPlan,
                iprInstructionList: fixIPRInstructions(treatmentPlan.iprInstructionList),
            },
        },
    })
}

export const changeSegment = (segment, name, value) => ({
    type: type.CHANGE_SEGMENT,
    payload: {
        segment,
        name,
        value,
    },
})

export const changeTreatmentPlan = (name, value) => ({
    type: type.CHANGE_TREATMENT_PLAN,
    payload: {
        name,
        value,
    },
})

export const changeIPRInstructions = (value) => ({
    type: type.CHANGE_TREATMENT_PLAN,
    payload: {
        iprInstructions: value,
    },
})

export const changeExistingCondition = (name, value) => {
    return changeSegment(EXISTING_CONDITION, name, value)
}

export const changeInstruction = (name, value) => {
    return changeSegment(INSTRUCTION_LIST, name, value)
}

export const changeDoNotMove = (name, value) => {
    return changeSegment(DO_NOT_MOVE, name, value)
}

export const changeLeaveSpaceOpen = (name, value) => {
    return changeSegment(LEAVE_SPACES_OPEN, name, value)
}

export const changeIPRInstruction = (name, value) => {
    return changeSegment(IPR_INSTRUCTION, name, value)
}

export const saveTreatmentPlanRequest = () => ({
    type: type.SAVE_TREATMENT_PLAN_REQUEST,
})

export const saveTreatmentPlanSuccess = (treatmentPlan) => ({
    type: type.SAVE_TREATMENT_PLAN_SUCCESS,
    payload: {
        treatmentPlan,
    },
})

export const saveTreatmentPlanError = (error) => ({
    type: type.SAVE_TREATMENT_PLAN_ERROR,
    payload: {
        error,
    },
})

export const saveTreatmentPlan = () => (dispatch, getState) => {
    const state = getState()
    const hasChanged = selector.selectHasChanged(state)

    if (!hasChanged) {
        return
    }
    const treatmentPlan = selector.selectTreatmentPlan(state)

    dispatch(saveTreatmentPlanRequest())

    post('/api/treatment/plan/save', treatmentPlan)
        .then(treatmentPlan => {
            dispatch(saveTreatmentPlanSuccess(treatmentPlan))
        })
        .catch(error => {
            dispatch(saveTreatmentPlanError(error))
        })
}



// WEBPACK FOOTER //
// ./src/modules/treatment/state/plan/action.js